module.exports = __webpack_public_path__ + "static/img/main-banner3.dd2340c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-banner3.png
// module id = jS8J
// module chunks = 0